/** Textes de la recherche (bloc i18n « search »), partagés par HeaderSearch et SearchResults. */
import { translate } from '../../i18n';

/** Bloc « search » de la langue courante ; le français si la langue n'en a pas (DE). */
export const searchTexts = (lang) => translate('search', lang) || translate('search', 'FR');

/** « Résultats pour « {q} » » + { q: 'maïs' }. */
export const fill = (text, values) =>
    Object.entries(values).reduce((result, [key, value]) => result.replace(`{${key}}`, value), text || '');

/** Clés `<key>_one` / `<key>_other` : « 1 produit », « 4 produits ». */
export const plural = (t, key, n) => fill(n === 1 ? t[`${key}_one`] : t[`${key}_other`], { n });

/** Libellé d'une entrée du catalogue renvoyée par le backend (labelFr / labelEn). */
export const labelOf = (entry, lang) => (lang === 'EN' ? entry.labelEn : entry.labelFr);
